import { render, staticRenderFns } from "./NotificaGerente.vue?vue&type=template&id=1390294e&"
import script from "./NotificaGerente.vue?vue&type=script&lang=js&"
export * from "./NotificaGerente.vue?vue&type=script&lang=js&"
import style0 from "./NotificaGerente.vue?vue&type=style&index=0&id=1390294e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports